import { render, staticRenderFns } from "./ResearchInformation.vue?vue&type=template&id=46edd4af&scoped=true"
import script from "./ResearchInformation.vue?vue&type=script&lang=js"
export * from "./ResearchInformation.vue?vue&type=script&lang=js"
import style0 from "./ResearchInformation.vue?vue&type=style&index=0&id=46edd4af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46edd4af",
  null
  
)

export default component.exports